// mutation types
export const SET_ERROR = "setError";
import PouchDB from "pouchdb";
var db = new PouchDB("agricactus");

const state = {
  recolecciones: [],
  test: [],
  isAsistencias: false,
  jornadaId: 0, //NEW
  areaId: 0, //NEW,
  actividadId: 0, //NEW,
  semaforo: "danger",
  data:null,
};

const getters = {};

const actions = {
  async getRecoleccion(context) {
    context.commit("resetR");
    await db
      .allDocs({ include_docs: true })
      .then(function(result) {
        const data = [];
        result.rows.map(x => data.push(x.doc));
        context.commit("storeR", data);
      })
      .catch(function(err) {
        console.log(err);
      });
    context.commit("loadedAsistencias");
  },
  update(context, { _id, _rev, viaje ,cuadrilleroId, equipoId, contratistaId, variedadId, cuadroId , palletTipoId , cantidad ,camionId,cultivoId}){
    db.put({
      _rev,
      _id,
      viaje,
      cuadrilleroId,
      equipoId,
      contratistaId,
      variedadId,
      cuadroId,
      palletTipoId,
      cantidad,
      camionId,
      cultivoId
    });
  },
  removeRecoleccion(context, { _id, _rev }){
     db.remove(_id, _rev)
  },
  storeRecoleccion(context, { cuadrilleroId, equipoId, contratistaId, variedadId, cuadroId , palletTipoId , cantidad ,camionId, cultivoId}) {
    let randomStr = Math.random()
      .toString(36)
      .substring(7);
    const id = new Date().toISOString() + randomStr  + cuadrilleroId.toString();
    db.put({
      _id: id,
      cuadrilleroId,
      equipoId,
      contratistaId,
      variedadId,
      cuadroId,
      palletTipoId,
      cantidad,
      camionId,
      cultivoId,
      viaje: null
    })
      .then(function() {
        context.dispatch("getRecoleccion");
      })
      .catch(function(err) {
        console.log(err);
      });
  },
  resetDb(context){
    db.destroy().then(() => {
      db = new PouchDB("agricactus");
      context.dispatch("getRecoleccion");
    })
  },

 /* updateAsistencia(context, data) {
    db.destroy().then(() => {
      db = new PouchDB("agricactus");
      if (data.length !== 0) {
        data.forEach(async user => {
          const date = new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "/");
          const jornada_id = user.jornadaId;
          const user_id = user.usuarioId;
          const actividadId = user.actividadId;
          const cuadroId = user.cuadroId;
          let randomStr = Math.random()
            .toString(36)
            .substring(7);
          const id = new Date().toISOString() + randomStr + user.id.toString();
          await db
            .put({ _id: id, date, jornada_id, user_id, actividadId, cuadroId })
            .then(function() {})
            .catch(function(err) {
              console.log(err);
            });
        });
        // context.dispatch("getAsistencias")
      }
      context.commit("storeAsistencia", data);
      context.commit("loadedAsistencias");
    });
  }, */

  getJornadaId() {
    return state.jornadaId;
  },

  getAreaId() {
    return state.areaId;
  },

  getActividadId() {
    return state.actividadId;
  }
};

const mutations = {
  resetR(state) {
    state.recolecciones = [];
  },
  loadedAsistencias(state) {
    state.isAsistencias = true;
  },
  changeSemaforo(state, semaforo) {
    state.semaforo = semaforo;
  },
  addData(state, data){
    state.data = data
  },
  storeR(state, recolecciones) {
    state.recolecciones = recolecciones;
  },
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  saveActividad(state, actividadId) {
    state.actividadId = actividadId;
  },
  saveJornada(state, jornadaId) {
    state.jornadaId = jornadaId;
  },
  saveArea(state, areaId) {
    state.areaId = areaId;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
